import React, { useEffect } from 'react'
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, navigate, useNavigate } from 'react-router-dom';
import { Container, Nav, Navbar, Row } from 'react-bootstrap';
import './DeliveryLogin.css'
import AdminNav from '../AdminNav';
import DeliveryNav from './DeliveryNav';


const DeliveryHeader = () => {

  const navigate = useNavigate();

  const backToMainPage = () => {
    sessionStorage.clear();
    navigate('/deliveryLogin')
  }
  const userdata = JSON.parse(sessionStorage.getItem('userdata'));
  const email = userdata ? userdata.login_id : '';

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const navbar = document.querySelector(".navbar");
  //     if (window.scrollY > 100) {
  //       navbar.classList.add("fixed-top", "fixed-background");
  //     } else {
  //       navbar.classList.remove("fixed-top", "fixed-background");
  //     }
  //   };

  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);
 
  return (
   <Container fluid className='m-0 p-0 '>
      <div className='m-0 p-0 '>
        <div className='m-0'>
          <DeliveryNav />
        </div>
        
        {/* <Container fluid>
          <Navbar className='rounded mt-2' expand="lg" style={{ backgroundColor:"rgb(47, 79, 79)" }}>
            <Nav
    className="ms-auto my-md-2m-0 p-0 my-lg-0  fw-bolder" style={{fontSize:"14px",fontFamily:"monospace"}}>

      <Nav.Link href="/#/deliveryDashboard"  className='me-md-5 me-3' style={{color:"white"}}>Dashboard</Nav.Link>
  </Nav>
          </Navbar>
        </Container> */}
      </div>
      <Row className='m-0 p-0 fixed-bottom   py-1' style={{ backgroundColor:"rgb(47, 79, 79)", display: "flex", justifyContent: "center", alignContent: "center", fontFamily: "monospace", color: "white" }}>
        <h6 className='text-center '>2023 DESIGN & DEVELOPED BY | TechnoAarv Solution</h6>
      </Row>
    </Container>
  )
}

export default DeliveryHeader








// import React, { useState } from 'react';
// import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

// function App() {
//   const [search, setSearch] = useState('');
//   const [desserts] = useState([
//     { name: 'Frozen Yogurt', category: 'Dairy', calories: 159, fat: 6.0, carbs: 24, protein: 4.0, iron: '1%' },
//     { name: 'Ice cream sandwich', category: 'Dairy', calories: 237, fat: 9.0, carbs: 37, protein: 4.3, iron: '1%' },
//     { name: 'Eclair', category: 'Pastry', calories: 262, fat: 16.0, carbs: 23, protein: 6.0, iron: '7%' },
//     { name: 'Cupcake', category: 'Pastry', calories: 305, fat: 3.7, carbs: 67, protein: 4.3, iron: '8%' },
//     { name: 'Gingerbread', category: 'Pastry', calories: 356, fat: 16.0, carbs: 49, protein: 3.9, iron: '16%' },
//     { name: 'Jelly bean', category: 'Candy', calories: 375, fat: 0.0, carbs: 94, protein: 0.0, iron: '0%' },
//     { name: 'Lollipop', category: 'Candy', calories: 392, fat: 0.2, carbs: 98, protein: 0, iron: '2%' },
//     { name: 'Honeycomb', category: 'Candy', calories: 408, fat: 3.2, carbs: 87, protein: 6.5, iron: '45%' },
//     { name: 'Donut', category: 'Pastry', calories: 452, fat: 25.0, carbs: 51, protein: 4.9, iron: '22%' },
//     { name: 'KitKat', category: 'Candy', calories: 518, fat: 26.0, carbs: 65, protein: 7, iron: '6%' }
//   ]);

//   const handleChange = (e) => {
//     setSearch(e.target.value);
//   };

//   const filteredDesserts = desserts.filter(dessert =>
//     dessert.name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div id="app">
//       <div id="inspire">
//         <Paper>
//           <div style={{ padding: '16px' }}>
//             <TextField
//               value={search}
//               onChange={handleChange}
//               variant="outlined"
//               label="Search"
//               size="small"
//               fullWidth
//             />
//           </div>
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Dessert (100g serving)</TableCell>
//                   <TableCell align="left" className="d-none">Category</TableCell>
//                   <TableCell>Calories</TableCell>
//                   <TableCell>Fat (g)</TableCell>
//                   <TableCell>Carbs (g)</TableCell>
//                   <TableCell>Protein (g)</TableCell>
//                   <TableCell>Iron (%)</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {filteredDesserts.map((dessert, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{dessert.name}</TableCell>
//                     <TableCell align="left" className="d-none">{dessert.category}</TableCell>
//                     <TableCell>{dessert.calories}</TableCell>
//                     <TableCell>{dessert.fat}</TableCell>
//                     <TableCell>{dessert.carbs}</TableCell>
//                     <TableCell>{dessert.protein}</TableCell>
//                     <TableCell>{dessert.iron}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Paper>
//       </div>
//     </div>
//   );
// }

// export default App;
